import { IPayloadCreateActivityEngagement } from 'app/api/activityEngagement/model'
import R from 'app/assets/R'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { useCreateActivityEngagement } from 'app/react-query/hook/activityEngagement'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

export const useHook = () => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IPayloadCreateActivityEngagement>()
  const modalRef = useRef<IRefModal>({})

  const { mutateAsync: mutateAsyncUpdate, isLoading } =
    useCreateActivityEngagement()

  const handleSubmit = async (values: IPayloadCreateActivityEngagement) => {
    const newAccount: IPayloadCreateActivityEngagement = {
      name: values?.name,
      description: values?.description,
      code: values?.code,
    }

    await mutateAsyncUpdate?.(newAccount)
    modalRef?.current?.hide?.()
    form?.resetFields()
    notificationController.success({
      message: t(R.strings.success),
    })
  }

  return {
    form,
    modalRef,
    handleSubmit,
    isLoading,
  }
}
